import { connect } from 'react-redux'
import { IStore } from '../../../reducers'
import { getReservationLabelPattern } from '../../../reducers/userObject/selectors/settings'
import { ITimePickerProps } from './TimePicker'

function mapStateToProps() {
  const patterns = getReservationLabelPattern

  return (state: IStore): Pick<ITimePickerProps, 'formatHours'> => {
    return patterns(state)
  }
}

export default connect(mapStateToProps()) as any
